import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import api from '../../../utils/api';
import { useDialog } from '../../../utils/dialog';
import snackbar from '../../../utils/snackbar';
import UserSelectDialog from '../../UserSelectDialog/UserSelectDialog';

const useAuditorSelectDialog = (companyId: number, excludedIds?: number[], updateData?: () => void) => {
    const { t } = useTranslation();

    const [isDialogOpen, setDialogOpen] = useState(false);
    const [openDialog, closeDialog] = useDialog();

    const openUserSelectDialog = useCallback(() => {
        setDialogOpen(true);
    }, [setDialogOpen]);

    const closeUserSelectDialog = useCallback((userId?: number) => {
        if (userId) {
            api.request('/companies/' + companyId + '/auditors', 'POST', { userId }).then(() => {
                snackbar.success(t('dialogs.user_select.auditor_saved'));
                if (updateData) {
                    updateData();
                }
            });
        }
        setDialogOpen(false);
    }, [companyId, t, updateData]);

    const askForAuditor = () => {
        openDialog({
            title: t('dialogs.user_select.select_auditor'),
            message: t('dialogs.user_select.select_auditor_desc'),
            actions: [
                {
                    text: t('dialogs.generic.no'),
                    color: 'secondary',
                    action: closeDialog
                },
                {
                    text: t('dialogs.generic.yes'),
                    color: 'primary',
                    action: () => {
                        openUserSelectDialog();
                        closeDialog();
                    }
                },
            ]
        });
    };

    const dialog = <UserSelectDialog open={isDialogOpen} onClose={closeUserSelectDialog} type='auditor' excludedIds={excludedIds} />;

    return [dialog, openUserSelectDialog, askForAuditor] as const;
};

export default useAuditorSelectDialog;
